import {
    Button,
    Dialog,
    DialogBackdrop,
    DialogPanel,
    DialogTitle,
} from "@headlessui/react";
import React, {useEffect, useState} from "react";
import {
    PresentationChartBarIcon,
    TrashIcon,
} from "@heroicons/react/24/outline";
import {useDarkMode} from "../../contexts/darkModeContext";
import {formatPhoneNumber} from "../GLOBAL/GlobalFunctions";
import soil from "../Soil";
import { ReactComponent as SOIL } from "../../customIcons/Soil.svg";

const SoilCard = ({ test }) => {

   
    
    const [isDeleting, setDeleting] = useState(false);

    // eslint-disable-next-line no-unused-vars
    const [salesID, setSalesID] = useState("");


    const { darkMode } = useDarkMode();
    
    // eslint-disable-next-line no-unused-vars
    const [disabled, setDisabled] = useState(false);
    

    useEffect(() => {
        setIsLoaded(true);
        setSalesID(test.salesID);
        // eslint-disable-next-line
    }, []);

    const [isLoaded, setIsLoaded] = useState(false); // State to track when the component is loaded
    const [isRemoving] = useState(false); // Track whether the item is being removed
    
    
    
    return (
        <div className={`w-full flex flex-col z-50 border-b-2 ${darkMode ? 'border-darkBgColor' : ''} p-3 transition-transform duration-500 ease-in-out ${isRemoving ? 'opacity-50 transform scale-75 rotate-1 bg-red-200' : ''} ${isLoaded ? '' : 'translate-x-full opacity-0'}`}>
        
            {/*{showFireworks && <FireworksEffect show={showFireworks} />}*/}
            
            {/*HEADER*/}
            <div className={`w-full flex flex-row ${darkMode ? 'hover:bg-white' : 'hover:bg-slate-400'} hover:bg-opacity-5 rounded-lg`}>
                
                <div className="w-full flex flex-row">
                    
                    {/*Buttons Delete*/}
                    <div className="flex flex-col items-center mr-3">
                        <Button
                            className={`${disabled ? 'hidden' : ''} ${soil.status === "active" ? 'hidden' : ''} rounded-full hover:animate-pulse mt-auto mb-auto h-8 w-8 items-center justify-center align-middle`}
                            onClick={() => setDeleting(true)}
                        >
                            <TrashIcon className="h-5 text-red-600 hover:text-red-600 hover:scale-110 m-auto"/>
                        </Button>
                    </div>
                    
                    {/*Sales Rep*/}
                    <div className="w-1/3 mr-1.5 flex flex-row items-center h-full mt-auto mb-auto">
                        
                        <div className={`size-8 flex bg-green-600/25 items-center justify-center p-1 rounded-full hover:scale-105 line-clamp-1`}>
                            <SOIL className={`size-5 text-green-600`}/>
                            {/*<div className="flex items-center justify-center h-full text-xs line-clamp-1">{soil.salesCode || "--"}</div>*/}
                        </div>
                        
                        <div className="justify-center flex flex-col h-full ml-2.5">
                            <div className="text-xs xl:text-sm line-clamp-1">{test.repName}</div>
                        </div>
                    
                    </div>
                    
                    {/*soil*/}
                    <div className="w-1/3 flex flex-row items-center h-full mt-auto mb-auto">
                        
                        <div className={`w-fit p-1 px-2 h-8 rounded-lg hover:scale-105 line-clamp-1 ${soil.existing ? `${darkMode ? 'bg-darkBgColor text-white' : 'bg-bgColor text-black border'}` : `${darkMode ? 'bg-darkBgColor text-white' : 'bg-bgColor text-black border'}`}`}>
                            <div className="flex items-center justify-center h-full text-xs line-clamp-1">{soil.soilCode || "- - - - -"}</div>
                        </div>
                        
                        <div className="justify-center flex flex-col h-full ml-2.5">
                            <div className="text-xs xl:text-sm line-clamp-1">{soil.name || "- - - - - - - - -"}</div>
                            <div className={`text-xxs text-gray-500 line-clamp-1`}>{soil.contact || "- - - - -"} | {formatPhoneNumber(soil.contactPhone) || "(---) --- - ----"}</div>
                        </div>
                    
                    
                    </div>
                    
                    
                    {/*YTD*/}
                    <div className="w-1/3 ml-5 flex flex-row h-full mt-auto mb-auto items-center justify-center">
                        
                        <div className={`w-1/2 p-1 h-8 bg-green-600/15 border border-green-600 rounded-full`}>
                            {/*<div className="flex items-center justify-center h-full text-sm px-2">$ {numberWithCommas(activeOrdersTotal.toFixed(2))}</div>*/}
                        </div>
                    
                    </div>
                    
                    
                    {/* Buttons DropDown */}
                    <div className={`flex flex-row items-center`}>
                        
                        
                        <Button
                            className={`rounded-full mt-auto mb-auto h-8 w-8 items-center justify-center align-middle`}
                            // onClick={toggleVisibility}
                            // onClick={() => handleViewAccount(soil)}
                        >
                            <PresentationChartBarIcon className="h-6 text-borderColor hover:text-bgLightGreen hover:stroke-2 hover:animate-pulse hover:scale-110 m-auto"
                            />
                        </Button>
                    </div>
                
                </div>
            
            </div>
            
            
            
            <Dialog open={isDeleting} onClose={setDeleting} className="relative z-50">
                <DialogBackdrop
                    transition
                    className="fixed inset-0 bg-gray-500/50 transition-opacity data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in"
              />
        
              <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
                <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
                  <DialogPanel
                    transition
                    className={`relative transform overflow-hidden rounded-lg ${darkMode ? 'bg-darkMainColor text-white' : 'bg-white text-black'} px-4 pb-4 pt-5 text-left shadow-xl transition-all data-[closed]:translate-y-4 data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in sm:my-8 sm:w-full sm:max-w-lg sm:p-6 data-[closed]:sm:translate-y-0 data-[closed]:sm:scale-95`}
                  >
                    <div className="sm:flex sm:items-start">
                      <div className="mx-auto flex size-12 shrink-0 items-center justify-center rounded-full bg-red-600/15 sm:mx-0 sm:size-10">
                        <TrashIcon aria-hidden="true" className="size-6 text-red-600" />
                      </div>
                      <div className="mt-3 text-center sm:ml-4 sm:mt-0 sm:text-left">
                        <DialogTitle as="h3" className="text-base font-semibold">
                          Delete | {soil.name}'s
                        </DialogTitle>
                        <div className="mt-2">
                          <p className="text-sm text-gray-500">
                            Are you sure you want to delete this soil? All of its data will be permanently removed from
                            our servers forever. This action cannot be undone. [Refresh soils After]
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="mt-5 sm:mt-4 sm:flex sm:flex-row-reverse">
                      <Button
                        type="button"
                        // onClick={() => handleDeletePending(soil.id)}
                        className="inline-flex w-full justify-center rounded-md bg-red-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-red-500 sm:ml-3 sm:w-auto"
                      >
                        {!soil.id ? 'Disabled' : 'Delete'}
                      </Button>
                      <Button
                        type="button"
                        data-autofocus
                        onClick={() => setDeleting(false)}
                        className={`mt-3 inline-flex w-full justify-center rounded-md ${darkMode ? 'bg-darkBgColor' : 'bg-white ring-1 ring-inset ring-gray-300'} px-3 py-2 text-sm font-semibold shadow-sm hover:bg-opacity-50 sm:mt-0 sm:w-auto`}
                      >
                        Cancel
                      </Button>
                    </div>
                  </DialogPanel>
                </div>
              </div>
            </Dialog>

        
        
        </div>
    )
}

export default SoilCard;
